import { TransactionSocketHandler } from "./";
import { Channel, Socket } from "phoenix";
import { API_ROOT } from "@/services/api";
import Honeybadger from "@honeybadger-io/js";
import { TransactionStatus } from "@/types/receipt";

const WS_ROOT = API_ROOT.replace("https", "wss");

class RealTransactionStatusSocket extends TransactionSocketHandler {
  public socket: Socket | undefined;
  public channel: Channel | undefined;

  public openConnection(receiptId: number): void {
    this.socket = new Socket(`${WS_ROOT}/socket`, {
      params: { receipt_id: receiptId },
    });
    this.socket.connect();
    this.socket.onError(async (err: any) => {
      Honeybadger.notify(err, { name: "Receipt socket error" });
      this.closeConnection();
      await this.onStatusUpdate({ state: TransactionStatus.ERROR });
    });
    this.channel = this.socket?.channel(`receipt:${receiptId}`);
    this.channel?.onError(async (err: any) => {
      Honeybadger.notify(err, { name: "Receipt channel error" });
      await this.onStatusUpdate({ state: TransactionStatus.ERROR });
    });
    this.channel?.join();
    this.channel?.on("state_update", this.onStatusUpdate.bind(this));
  }
  public closeConnection(): void {
    this.channel?.leave();
    this.socket?.disconnect();
  }

  public isConnected(): boolean {
    const state = this.channel?.state;
    return state === "joined" || state === "joining";
  }
}

export default RealTransactionStatusSocket;
